//@ts-ignore
// @ts-nocheck
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import Gateways from './component/gateways/Gateways'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import PaymentMethod from './component/PaymentMethod'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://239ac4f902079fc3effbd6991cef3a7f@o4508958151081984.ingest.us.sentry.io/4508958152458240"
});

const Provider = ({ payload: payload }) => {
  if (Object.keys(payload).length == 0) {

return false;

  
}
  // const secondAppRoot = document.createElement("div");
  // secondAppRoot.id = "second-app-root";
  // document.body.appendChild(secondAppRoot);
  const root = ReactDOM.createRoot(document.getElementById('root'))

  root.render(
    <BrowserRouter >
    {/* <button onClick={() => {throw new Error("This is your first error!");}}>Break the world</button>; */}
      <ToastContainer newestOnTop={true} />
      <PaymentMethod payload={payload} />

     
   </BrowserRouter>, 
   )
}
export default Provider
